import { updateDataNodeOperation } from './dataTreesActions';

export const DATA_EXTRACTION_RESET = 'DATA_EXTRACTION_RESET';
export const DATA_EXTRACTION_SET_PROJECT_ID_LISTEN_SOCKET =
  'DATA_EXTRACTION_SET_PROJECT_ID_LISTEN_SOCKET';

export const resetDataExtraction = () => {
  return {
    type: DATA_EXTRACTION_RESET
  };
};

export const setProjectContextListenerId = listeningDataTrees => {
  return {
    type: DATA_EXTRACTION_SET_PROJECT_ID_LISTEN_SOCKET,
    listeningDataTrees
  };
};

export const removeActiveProjectContextListener = () => {
  return (dispatch, getState, { apiClient, feathersClient }) => {
    const projectId = getState().projects.single.fileImport.listeningDataTrees;

    if (projectId !== false) {
      feathersClient.io.off(`projects/${projectId}/dataNodes`);
      dispatch(setProjectContextListenerId(false));
    }
  };
};

export const setProjectContextListener = () => {
  return (dispatch, getState, { apiClient, feathersClient }) => {
    let projectId = null;

    if (getState().projects.single.active) {
      projectId = getState().projects.single.active.id;

      feathersClient.io.on(`projects/${projectId}/dataNodes`, payload => {
        dispatch(updateDataNodeOperation(payload));
      });

      dispatch(setProjectContextListenerId(projectId));
    }
  };
};

export const callAlbum = () => {
  return async (dispatch, getState, { apiClient, feathersClient }) => {
    const projectId = getState().projects.single.fileImport.listeningDataTrees;
    await apiClient.call("Projects","albumImport", { projectId }, null, null);
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/fileImport.js